import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';
import { fragments as mediaFragments } from '../Media';

export const stickerFragment = gql`
  fragment StickerAll on Sticker {
    ...ContentfulSysId
    asset {
      ...AssetAll
    }
    position
    rotation
  }
  ${contentfulSysIdFragment}
  ${mediaFragments.all}
`;

export const stickerQuery = gql`
  query StickerQuery($preview: Boolean!, $locale: String!, $id: String!) {
    sticker(preview: $preview, locale: $locale, id: $id) {
      ...StickerAll
    }
  }
  ${stickerFragment}
`;
